export const getDashboardReportCards = (data = []) => {
  const regionCount = {};

  data.forEach((req) => {
    const regionName = req.regionName || 'Без района';
    if (!regionCount[regionName]) {
      regionCount[regionName] = 0;
    }
    regionCount[regionName]++;
  });

  const cards = Object.keys(regionCount).map((region) => ({
    title: region,
    count: regionCount[region],
  }));

  return cards;
};
